<template>
    <div>
        <modal-confirmar-etapa-anexo
            v-model="modalConfirmAnexo"
            :title="'Responder ' + tipo"
            text="Atenção, nenhum anexo foi"
            secondText="inserido, deseja continuar?"
            @fecharModalConfirm="naoContinuarSemAnexo"
            @cancelarAcao="naoContinuarSemAnexo"
            @confirmarAcao="enviarResposta"
        />
        <v-dialog v-model="value" scrollable persistent :max-width="maxWidth">
            <v-card>
                <v-card-title class="primary modal-title">
                    <span>Responder {{ tipo }}</span>
                    <v-spacer/>
                    <v-btn icon @click="fecharModal">
                        <v-icon size="20" color="white">close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text style="overflow-x: hidden">
                    <v-layout row wrap>
                        <campo-apresentacao labelPadrao="Data/Hora Criação" :text="item.dataCadastro | azDate"
                                            style="margin-right: 15%"/>

                        <campo-apresentacao labelPadrao="Data/Hora Envio" :text="item.dataEnvio | dataHumanizada"
                                            style="margin-right: 8%"/>

                        <campo-apresentacao v-if="item.fornecedor && item.fornecedor.razaoSocial" labelPadrao="Empresa"
                                            :text="item.fornecedor.razaoSocial"
                                            style="margin-right: 15%"/>
                        <campo-apresentacao v-else-if="item.nomeRazaoSocial" labelPadrao="Empresa"
                                            :text="item.nomeRazaoSocial"
                                            style="margin-right: 15%"/>
                        <campo-apresentacao v-else labelPadrao="Empresa" :text="'--'"
                                            style="margin-right: 15%"/>

                        <campo-apresentacao labelPadrao="Anexo" :text="''" :baixar="item.arquivoUri"
                                            style="margin-right: 15%"/>

                        <campo-apresentacao labelPadrao="Situação"
                                            :text="item.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao)"
                                            style="margin-right: 50px"/>
                    </v-layout>
                    <v-layout row wrap>
                        <campo-apresentacao
                            :labelPadrao="'Assunto ' + tipo"
                            :text="item.assunto"
                            styles="max-percent"
                            :tabulacao="true"
                        />
                    </v-layout>
                    <p class="text-campo" style="margin-top: 10px">Resposta
                        <span class="ml-1 red--text">*</span>
                        <span class="ml-1 red--text"
                              v-if="limiteTextoAtingido">Limite máximo de caracteres atingido!</span></p>
                    <v-textarea class="textarea-resposta" placeholder="Informe a resposta..."
                                v-model="dadosGerais.resposta" v-on:keyup="contarTamanhoTexto" counter/>
                    <v-layout row wrap>
                        <div v-if="!esclarecimento" style="width: 200px; margin-right: 50px">
                            <p class="text-campo" style="margin-bottom: 5px">Análise</p>
                            <v-select
                                v-model="dadosGerais.analise"
                                class="select-analise"
                                placeholder="Selecione"
                                :items="tiposAnalise"
                                :insertNullItem="false"
                                name="analiseSelect">
                            </v-select>
                        </div>
                    </v-layout>
                    <div>
                        <p class="text-campo" style="margin-bottom: 5px">Anexo </p>
                        <licitacao-esclarecimento-anexo style="margin-top: -20px" tipo="pregoeiro"
                                                        @uploadArquivo="setarArquivoUpload"
                                                        @removerArquivoUpload="removerArquivoUpload"
                                                        @configuracaoRepositorio="setarRepositorio"/>
                    </div>
                </v-card-text>
                <div class="az-actions-form actions-modal">
                    <button class="action-secundary-button" @click="fecharModal">Cancelar</button>
                    <button v-if="dadosGerais.resposta" class="action-primary-button"
                            @click.prevent="confirmarResposta">
                        Enviar Resposta
                    </button>
                    <div v-else>
                        <v-tooltip top nudge-top="10" max-width="200">
                            <template v-slot:activator="{ on }">
                                <button v-on="on" class="action-primary-button-disabled btn-disabled">Enviar Resposta
                                </button>
                            </template>
                            É necessário que todos os campos obrigatórios sejam preenchidos para continuar.
                        </v-tooltip>
                    </div>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapActions} from 'vuex'
import {actionTypes, tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
import CampoApresentacao from '@/commons/components/campos/campo-apresentacao'
import ModalConfirmarEtapaAnexo from '@/commons/components/ModalConfirmarEtapaAnexo'
import BotaoAnexo from '@/commons/components/botoes/BotaoAnexo'
import LicitacaoEsclarecimentoAnexo from '../../../commons/LicitacaoEsclarecimentoAnexo'

    export default {
        name: 'ModalResponderEsclarecimentoImpugnacao',
        components: {LicitacaoEsclarecimentoAnexo, BotaoAnexo, ModalConfirmarEtapaAnexo, CampoApresentacao},
        props: {
            value: Boolean,
            item: Object,
            tipo: {
                type: String,
                default: 'Esclarecimento'
            },
            esclarecimento: {
                type: Boolean,
                default: true
            },
            convidado : {
                type: Boolean,
                default: false
            },
            maxWidth: {
                type: String,
                default: '800'
            },
        },
        data() {
            return {
                tiposSituacaoEsclarecimentoImpugnacao,
                modalConfirmAnexo: false,
                dadosGerais: {
                    esclarecimento: null,
                    usuario: null,
                    dataCadastro: null,
                    fornecedor: null,
                    arquivoNome: null,
                    arquivoUri: null,
                    tipo: null,
                    assunto: null,
                    resposta: null,
                    anexoResposta: null,
                    analise: null,
                    anexoUri: null,
                    anexoNome: null,
                    convidado : false,
                    anexoUpload: null,
                    repositorioUri: null
                },
                maxTextArea: 510,
                totalRemainCount: 510,
                limiteTextoAtingido: false,
                tiposAnalise: ['Deferido', 'Indeferido'],
                repository: 'repo1:licitacao',
            }
        },
        methods: {
            ...mapActions([
                actionTypes.INSERIR_RESPOSTA
            ]),
            fecharModal() {
                this.$emit('fecharModal')
            },
            naoContinuarSemAnexo(){
                this.modalConfirmAnexo = false
            },
            async confirmarResposta() {
                if (!this.dadosGerais.anexoUri && !this.dadosGerais.anexoUpload) {
                    this.modalConfirmAnexo = true
                    return
                }
                await this.enviarResposta()
            },
            async enviarResposta(){
              this.setarDadosGerais();
            try {
                this.dadosGerais.convidado = this.convidado;
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Enviando resposta...')

                await this.inserirResposta(this.dadosGerais);

                this.mostrarNotificacaoSucessoDefault()
                this.fecharModal();
            } catch (error) {
                let mensagemErro = 'Ocorreu um erro ao enviar a resposta.';

                if (error.response && error.response.data && error.response.data.message) {
                    mensagemErro = error.response.data.message;
                }

                this.mostrarMensagemErro(mensagemErro);
            } finally {
                this.desabilitarLoadingGlobal();
            }
        },
        contarTamanhoTexto() {
            this.totalRemainCount = this.maxTextArea - this.dadosGerais.resposta.length;

            this.limiteTextoAtingido = this.totalRemainCount < 0;
            if (this.limiteTextoAtingido) this.dadosGerais.resposta = this.dadosGerais.resposta.slice(0, this.totalRemainCount)
        },
        setarDadosGerais() {
            this.dadosGerais.tipo = (this.esclarecimento ? 'ESCLARECIMENTO' : 'IMPUGNACAO')
            this.dadosGerais.usuario = this.$store.state.loki.user.id
            this.dadosGerais.dataCadastro = this.item.dataCadastro
            this.dadosGerais.fornecedor = this.item.fornecedor
            this.dadosGerais.arquivoNome = this.item.arquivoNome
            this.dadosGerais.arquivoUri = this.item.arquivoUri
            this.dadosGerais.assunto = this.item.assunto
            this.dadosGerais.esclarecimento = this.item.id
        },
        setarArquivoUpload(arquivoUpload) {
            this.dadosGerais.anexoUpload = arquivoUpload
        },
        removerArquivoUpload() {
            this.dadosGerais.anexoUpload = null
        },
        setarRepositorio(repositorioUri) {
            this.dadosGerais.repositorioUri = repositorioUri
        },
    }
}
</script>

<style lang="stylus">

.max-percent
    max-width 90%

.tabulacao-content
    margin-left 10px

.modal-title
    margin: 0
    padding: 10px 20px
    font-size: 18px !important
    color: white

.actions-modal
    border-top solid thin rgba(0, 0, 0, .12)
    padding-top 10px
    margin-top 0

&-conteudo
    min-height 350px

.container-header-text
    display flex
    flex-direction row
    justify-content center
    align-items center

.text-campo
    margin 0
    font-size 14px
    font-weight bold
    color #3A6861 !important

.textarea-resposta
    padding-top 0 !important

    textarea
        padding 5px !important
        color #777 !important

    .v-input__slot
        border 1px solid #CCCCCC
        border-radius 5px

.select-analise
    margin 0 !important
    padding-top 0 !important

    .v-select__selections
        color #777 !important
</style>